import create_membership_methods_part1 from './create_membership_methods_part1';
import create_membership_methods_part2 from './create_membership_methods_part2';
import create_membership_methods_part3 from './create_membership_methods_part3';

export default {
  ...create_membership_methods_part1,
  ...create_membership_methods_part2,
  ...create_membership_methods_part3
};

